import { FormContent } from './FormContent';
import { FormInputText } from './FormInput';
import { FormInputActionBase } from './FormInputActions';
import { FormInputContent } from './FormInputContent';
import { Provider } from './FormProvider';
import { FormRoot } from './FormRoot';

export const FormBase = {
  Root: FormRoot,
  Content: FormContent,
  InputActions: FormInputActionBase,
  InputContent: FormInputContent,
  InputText: FormInputText,
  Provider,
};
